import { Routes } from '@angular/router';

export const privacyPolicyRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./privacy-policy.page').then((m) => m.PrivacyPolicyPage),
  },
];
